// src/ui/styles/thumbnails.css.js
import { css } from "lit";

export const thumbnailsStyles = css`
  /* --------------------------------------------------------------------------
   * Scroll Container
   * -------------------------------------------------------------------------- */

  .thumb-strip {
    position: relative;
    width: 100%;
    height: 110px;

    overflow-x: auto;
    overflow-y: hidden;

    white-space: nowrap;

    scrollbar-width: none;
    -ms-overflow-style: none;

    /* Ensure wheel events scroll horizontally */
    overscroll-behavior: contain;
    touch-action: pan-x;

    pointer-events: auto;
  }

  .thumb-strip::-webkit-scrollbar {
    display: none;
  }

  .thumb-strip.empty {
    display: none;
  }

  /* --------------------------------------------------------------------------
   * Virtualization Layers
   * -------------------------------------------------------------------------- */

  /* Defines the full scrollable width */
  .virtual-spacer {
    display: block;
    height: 100%;
    pointer-events: none;
  }

  /* Floating window containing only visible thumbnails */
  .virtual-window {
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    display: flex;

    /* Do NOT block scroll wheel */
    pointer-events: none;

    will-change: transform;
  }

  /* Restore clickability for thumbnails */
  .virtual-window .thumb {
    pointer-events: auto;
  }

  /* --------------------------------------------------------------------------
   * Thumbnail Item
   * -------------------------------------------------------------------------- */

  .thumb {
    width: 100px;
    height: 100px;
    margin: 5px;

    border-radius: 10px;
    overflow: hidden;
    flex-shrink: 0;

    cursor: pointer;

    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(6px);

    transition:
      transform 120ms ease,
      box-shadow 120ms ease;
  }

  .thumb:hover {
    transform: scale(1.06);
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.35);
  }

  .thumb.selected {
    outline: 3px solid var(--wa-accent, #4da3ff);
    transform: scale(1.08);
  }

  /* --------------------------------------------------------------------------
   * Image Thumbnails
   * -------------------------------------------------------------------------- */

  .thumb-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
  }

  /* --------------------------------------------------------------------------
   * Video Thumbnails
   * -------------------------------------------------------------------------- */

  .video-thumb {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .video-poster {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
  }

  .video-preview {
    position: absolute;
    inset: 0;

    width: 100%;
    height: 100%;
    object-fit: cover;

    opacity: 0;
    transition: opacity 200ms ease;

    pointer-events: none;
  }

  .thumb:hover .video-preview {
    opacity: 1;
  }

  /* --------------------------------------------------------------------------
   * Play Icon Overlay
   * -------------------------------------------------------------------------- */

  .play-icon {
    position: absolute;
    bottom: 6px;
    right: 6px;

    width: 18px;
    height: 18px;

    background: rgba(0, 0, 0, 0.55);
    border-radius: 50%;

    pointer-events: none;

    mask: url("data:image/svg+xml,%3Csvg fill='white' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5v14l11-7z'/%3E%3C/svg%3E")
      center / 60% no-repeat;
  }
`;
